module.exports = __webpack_public_path__ + "static/media/game.268bc4ef.svg";